import { useState, type ReactNode } from "react";

import { ActionIcon, Center, Group, Popover } from "@mantine/core";
import { useClickOutside } from "@mantine/hooks";

import type { NavigationGroup } from "@/components/Navbar/useNavigationElements";

interface NavbarIconGroupItemProps {
  navGroup: NavigationGroup;
  children: ({ close }: { close: () => void }) => ReactNode;
}

export const NavbarIconGroupItem = ({ navGroup, children }: NavbarIconGroupItemProps) => {
  const [opened, setOpened] = useState(false);
  const togglePopover = () => setOpened((prev) => !prev);
  const closePopover = () => setOpened(false);

  const ref = useClickOutside(() => setOpened(false));

  return (
    <Popover position="right" withArrow shadow="md" opened={opened}>
      <Popover.Target>
        <Center>
          <ActionIcon size="lg" onClick={togglePopover}>
            {navGroup.icon}
          </ActionIcon>
        </Center>
      </Popover.Target>
      <Popover.Dropdown>
        <Group ref={ref} wrap="nowrap">
          {children({ close: closePopover })}
        </Group>
      </Popover.Dropdown>
    </Popover>
  );
};

export default NavbarIconGroupItem;
